export default __webpack_public_path__ + "static/media/top10.95693455.jpg";